<template>
  <div class="card mb-2 mt-2 ms-5 me-5">
    <div class="card-body">
      <h4 class="mt-3 mb-2">
        <strong>Servicios para {{ imgFormName }}</strong>
      </h4>
      <div class="table-responsive">
        <table class="mx-auto">
          <thead>
            <tr colspan="8"></tr>
          </thead>
          <tbody>
            <tr>
              <td class="lblform"><strong>Longitud de corte en cizalla: </strong>
                <br>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="checkbox" role="switch" id="flameCutService"
                    v-model="requestShearCut" @change="useShearCutService" />
                  <label class="form-check-label ms-1" for="flameCutService"><i>Utilizar servicio</i></label>
                </div>
              </td>
              <td class="inputForm">
                <input id="sheetAmountShearCut" type="number" min="0" class="form-control" placeholder="0"
                  v-model="shearCutService" :disabled="!isShearCutAvailable"
                  :class="{ 'avilable-input': isShearCutAvailable }" />Digite en
                centímetros.
              </td>
              <td class="lblform"><strong>Longitud de dobleces:</strong></td>
              <td class="inputForm">
                <input id="sheetAmountFold" type="number" min="0" class="form-control" placeholder="0"
                  v-model="foldService" :disabled="!isFoldAvailable"
                  :class="{ 'avilable-input': isFoldAvailable }" />Digite en
                centímetros.
              </td>
              <td class="lblform"><strong>Peso para rolado recto:</strong></td>
              <td class="inputForm">
                <input id="sheetAmountRolled" type="number" min="0" class="form-control" placeholder="0"
                  v-model="rolledService" :disabled="!isRolledAvailable"
                  :class="{ 'avilable-input': isRolledAvailable }" />Digite en
                Kilos.
              </td>
              <td class="lblform"><strong>Longitud de <br>soldadura con electrodo:</strong></td>
              <td class="inputForm">
                <input id="sheetAmountWeldingElectrode" type="number" min="0" class="form-control" placeholder="0"
                  v-model="weldingElectrodeService" :disabled="!isWeldingElectrodeAvailable"
                  :class="{ 'avilable-input': isWeldingElectrodeAvailable }" />Digite en centímetros.
              </td>
            </tr>
            <tr>
              <td class="lblform"><strong>Longitud de corte en plasma:</strong>
                <br>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="checkbox" role="switch" id="plasmaService"
                    v-model="requestPlasma" @change="usePlasmaService" />
                  <label class="form-check-label ms-1" for="plasmaService"><i>Utilizar servicio</i></label>
                </div>
              </td>
              <td class="inputForm">
                <input id="sheetAmountPlasmaCutting" type="number" min="0" class="form-control" placeholder="0"
                  v-model="plasmaService" :disabled="!isPlasmaAvailable"
                  :class="{ 'avilable-input': isPlasmaAvailable }" />Digite
                en centímetros.
              </td>
              <td class="lblform">
                <strong> Cantidad de agujeros, <br> punzonados o destijeres.</strong> <br> Menores a 40mm:
              </td>
              <td class="inputForm">
                <input id="sheetAmountPunched1" type="number" min="0" class="form-control" placeholder="0"
                  v-model="punching1Service" :disabled="!isPunching1Available"
                  :class="{ 'avilable-input': isPunching1Available }" /> Unidades.
              </td>
              <td class="lblform"><strong>Peso para rolado cónico:</strong></td>
              <td class="inputForm">
                <input id="sheetAmountRolledC" type="number" min="0" class="form-control" placeholder="0"
                  v-model="conicalRolledService" :disabled="!isConicalRolledAvailable"
                  :class="{ 'avilable-input': isConicalRolledAvailable }" />Digite en
                Kilos.
              </td>
              <td class="lblform"><strong>Longitud de <br>
                  soldadura con MIG:</strong></td>
              <td class="inputForm">
                <input id="sheetAmountWeldingMig" type="number" min="0" class="form-control" placeholder="0"
                  v-model="weldingMigService" :disabled="!isWeldingMigAvailable"
                  :class="{ 'avilable-input': isWeldingMigAvailable }" />Digite en
                centímetros.
              </td>
            </tr>
            <tr>
              <td class="lblform"><strong>Longitud de corte con laser:</strong>
                <br>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="checkbox" role="switch" id="laserCutService"
                    v-model="requestLaser" @change="useLaserService" />
                  <label class="form-check-label ms-1" for="laserCutService"><i>Utilizar servicio</i></label>
                </div>
              </td>
              <td class="inputForm">
                <input id="sheetAmountFlameCutting" type="number" min="0" class="form-control" placeholder="0"
                  v-model="laserService" :disabled="!isLaserAvailable"
                  :class="{ 'avilable-input': isLaserAvailable }" />Digite
                en centímetros.
              </td>
              <td class="lblform">
                <strong>Cantidad de agujeros, <br> punzonados o destijeres.</strong> <br> Mayores a 40mm:
              </td>
              <td class="inputForm">
                <input id="sheetAmountPunched2" type="number" min="0" class="form-control" placeholder="0"
                  v-model="punching2Service" :disabled="!isPunching2Available"
                  :class="{ 'avilable-input': isPunching2Available }" />Unidades.
              </td>
              <td class="lblform"><strong>Peso para abombado:</strong></td>
              <td class="inputForm">
                <input id="sheetAmountConvex" type="number" min="0" class="form-control" placeholder="0"
                  v-model="convexService" :disabled="!isConvexAvailable"
                  :class="{ 'avilable-input': isConvexAvailable }" />Digite en
                Kilos.
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td class="lblform"><strong>Longitud de oxicorte:</strong>
                <br>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="checkbox" role="switch" id="flameCutService"
                    v-model="requestFlameCut" @change="useFlameCutService" />
                  <label class="form-check-label ms-1" for="flameCutService"><i>Utilizar servicio</i></label>
                </div>
              </td>
              <td class="inputForm">
                <input id="sheetAmountFlameCutting" type="number" min="0" class="form-control" placeholder="0"
                  v-model="flameCuttingService" :disabled="!isFlameCutAvailable"
                  :class="{ 'avilable-input': isFlameCutAvailable }" />Digite
                en centímetros.
              </td>
              <td></td>
              <td></td>
              <td class="lblform"><strong>Peso para pestañado:</strong></td>
              <td class="inputForm">
                <input id="sheetAmountEyelashed" type="number" min="0" class="form-control" placeholder="0"
                  v-model="eyelashedService" :disabled="!isEyelashedAvailable"
                  :class="{ 'avilable-input': isEyelashedAvailable }" />Digite en
                Kilos.
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <p> <strong>Precio de otros servicios: </strong> <br> (Manipulación, transporte, embalaje, etc.)</p>
              </td>
              <td>
                <p><strong>$</strong></p>
              </td>
              <td><input id="sheetAmountOther" type="number" min="0" class="form-control" placeholder="0" step="1000"
                  v-model="otherService" @change="useOtherService"
                  :class="{ 'avilable-input': isOtherServices }" />Digite
                el
                valor en pesos.</td>
              <td><strong>Observaciones adiconales:</strong> </td>
              <td colspan="3">
                <textarea class="" id="sheetComments" type="text" v-model="comments"></textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
  props: {
    getMainSheetType: Number,
    getLengthValue: Number,
    getWidthValue: Number,
    getSheetImageInfo: Object,
    getWeight: Number,
    getMeasures: Object,
  },
  data() {
    return {
      sheetTypeInfo: [],
      imgFormName: "",
      distancesValue: [],
      diametersValue: [],
      radiusValue: [],
      anglesValue: [],
      shearCutServiceConception: "",
      otherCuttingServicesConception: "",
      shearCutConception: 0,
      otherCuttingSConception: 0,
      // Calculo de servicios en metros, kilos y unidades - Campos de servicios
      shearCutService: 0,
      foldService: 0,
      plasmaService: 0,
      laserService: 0,
      flameCuttingService: 0,
      rolledService: 0,
      conicalRolledService: 0,
      punching1Service: 0,
      punching2Service: 0,
      weldingElectrodeService: 0,
      weldingMigService: 0,
      convexService: 0,
      eyelashedService: 0,
      otherService: 0,
      comments: "",
      //Valor acumulado en pesos de los servicios
      totalService: 0,
      //Servicios que se pueden utilizar a cambio de otro
      requestPlasma: false,
      requestFlameCut: false,
      requestShearCut: false,
      requestLaser: false,
      //Alertas sobre el espesor de la lamina y la facilidad del servicio
      generalAlert: "Servicio no disponible, para el espesor comercial solicitado.",
      //Desahabilar los campos dependiendo de la disponibilidad del servicio
      isShearCutAvailable: false,
      isFoldAvailable: false,
      isPlasmaAvailable: false,
      isLaserAvailable: false,
      isFlameCutAvailable: false,
      isRolledAvailable: false,
      isConicalRolledAvailable: false,
      isWeldingElectrodeAvailable: false,
      isWeldingMigAvailable: false,
      isPunching1Available: false,
      isPunching2Available: false,
      isConvexAvailable: false,
      isEyelashedAvailable: false,
      isOtherServices: true,
      //Constantes
      piConstat: 3.1416,

    }
  },
  computed: {
    totalServiceAmount() {
      return (
        this.calculateShearCut() +
        this.calculateFold() +
        this.calculateFlameCutting() +
        this.calculatePlasmaCutting() +
        this.calculateLaserCutting() +
        this.calculateRolled() +
        this.calculateConicalRolled() +
        this.calculateWeldingElectrode() +
        this.calculateWeldingMig() +
        this.calculateEyelashed() +
        this.calculateConvex() +
        this.calculateOtherServices()
      );
    },
  },
  watch: {
    getMainSheetType(newVal) {
      if (newVal !== null) {
        this.assingServices();
        this.totalService = 0;
        this.getSheetTypeById();
      }
    },
    getWeight(newVal) {
      if (newVal !== null) {
        this.callCalculateServices();
      }
    },
    getSheetImageInfo(newVal) {
      if (newVal != null) {
        this.assingServices();
      }
    },
    getMeasures(newVal) {
      if (newVal != null) {
        this.getMeasuresAndTransform();
      }
    },
    totalServiceAmount(newTotalServiceAmount) {
      // Cuando totalServiceAmount cambia, actualiza totalService
      this.totalService = newTotalServiceAmount;
    },
  },
  methods: {
    useShearCutService() {
      if (this.requestShearCut) {
        this.plasmaService = 0;
        this.flameCuttingService = 0;
        this.laserService = 0;
        this.callCalculateServices();
      } else {
        this.shearCutService = 0;
        this.punching1Service = 0;
        this.punching2Service = 0;
        this.callCalculateServices();
      }
    },
    usePlasmaService() {
      //console.log(this.requestPlasma);
      if (this.requestPlasma) {
        this.shearCutService = 0;
        this.flameCuttingService = 0;
        this.laserService = 0;
        this.callCalculateServices();
      } else {
        //this.calculateShearCut();
        this.plasmaService = 0;
        this.callCalculateServices();
      }
    },
    useLaserService() {
      if (this.requestLaser) {
        this.shearCutService = 0;
        this.plasmaService = 0;
        this.flameCuttingService = 0;
        this.callCalculateServices();
      } else {
        //this.calculateShearCut();
        this.laserService = 0;
        this.callCalculateServices();
      }
    },
    useFlameCutService() {
      if (this.requestFlameCut) {
        this.shearCutService = 0;
        this.plasmaService = 0;
        this.laserService = 0;
        this.callCalculateServices();
      } else {
        //this.calculateShearCut();
        this.flameCuttingService = 0;
        this.callCalculateServices();
      }
    },
    useOtherService() {
      this.callCalculateServices();
    },
    assingServices() {
      //console.log(this.getSheetImageInfo);
      // Información de servicios de acuerdo a la imagen
      this.imgFormName = this.getSheetImageInfo.imgForm.toLowerCase();
      this.getSheetImageInfo.imgServiceShearCut === "aplica" ? this.isShearCutAvailable = true : this.isShearCutAvailable;
      this.getSheetImageInfo.imgServiceFold > 0 ? this.isFoldAvailable = true : this.isFoldAvailable;
      this.getSheetImageInfo.imgServicePlasmaCutting === "aplica" ? this.isPlasmaAvailable = true : this.isPlasmaAvailable;
      this.getSheetImageInfo.imgServiceFlameCutting === "aplica" ? this.isFlameCutAvailable = true : this.isFlameCutAvailable;
      this.getSheetImageInfo.imgServiceWeldingElectrode === "aplica" ? this.isWeldingElectrodeAvailable = true : this.isWeldingElectrodeAvailable;
      this.getSheetImageInfo.imgServiceWeldingMig === "aplica" ? this.isWeldingMigAvailable = true : this.isWeldingMigAvailable;
      this.getSheetImageInfo.imgServiceRolled === "aplica" ? this.isRolledAvailable = true : this.isRolledAvailable;
      this.getSheetImageInfo.imgServiceRolledConical === "aplica" ? this.isConicalRolledAvailable = true : this.isConicalRolledAvailable;
      this.getSheetImageInfo.imgServicePunching1 > 0 ? this.isPunching1Available = true : this.isPunching1Available;
      this.getSheetImageInfo.imgServicePunching2 > 0 ? this.isPunching2Available = true : this.isPunching2Available;
      this.getSheetImageInfo.imgServiceConvex === "aplica" ? this.isConvexAvailable = true : this.isConvexAvailable;
      this.getSheetImageInfo.imgServiceEyelashed === "aplica" ? this.isEyelashedAvailable = true : this.isEyelashedAvailable;
      this.getSheetImageInfo.imgServiceLaserCutting === "aplica" ? this.isLaserAvailable = true : this.isLaserAvailable;
      this.getSheetImageInfo.imgServiceShearCutConception === "no_aplica" ? this.shearCutServiceConception = "" : this.shearCutServiceConception = this.getSheetImageInfo.imgServiceShearCutConception;
      this.getSheetImageInfo.imgOtherCuttingServicesConception === "no_aplica" ? this.otherCuttingServicesConception = "" : this.otherCuttingServicesConception = this.getSheetImageInfo.imgOtherCuttingServicesConception;
      //console.log(this.shearCutServiceConception);
      //console.log(this.otherCuttingServicesConception);
    },
    async getSheetTypeById() {
      if (this.getMainSheetType == 0) {
        console.log("Id de clasificación de lámina.");
      } else {
        try {
          let res = await axios.get(RUTA_SERVIDOR + "api/sheet/type/get", {
            params: {
              sheetType_id: this.getMainSheetType,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          });
          //console.log(res.data);
          if (!res.data) {
            console.log("There has been a different error with the data.");
          } else {
            console.log(res.data);
            this.sheetTypeInfo = res.data[0];
            //this.callCalculateServices();
          }
        } catch (err) {
          console.log(`There has been an error ${err}`);
        }
      }
    },
    callCalculateServices() {
      this.totalService = 0; // Reinicia totalService
      this.totalService += this.calculateShearCut();
      this.totalService += this.calculateFold();
      this.totalService += this.calculateFlameCutting();
      this.totalService += this.calculatePlasmaCutting();
      this.totalService += this.calculateLaserCutting();
      this.totalService += this.calculatePunching();
      this.totalService += this.calculateRolled();
      this.totalService += this.calculateConicalRolled();
      this.totalService += this.calculateConvex();
      this.totalService += this.calculateEyelashed();
      this.totalService += this.calculateWeldingElectrode();
      this.totalService += this.calculateWeldingMig();
      this.totalService += this.calculateOtherServices();
      this.$emit("sendServicesPrice", this.totalService);
    },
    calculateShearCut() {
      // console.log(this.shearCutConception);
      // console.log(this.sheetTypeInfo.thicknessCommercialMm);
      if (this.isShearCutAvailable && (this.sheetTypeInfo.thicknessCommercialMm
        <= 9) && (this.requestShearCut) && (this.shearCutConception > 0)) {
        // console.log("Entro al primer servicio!")
        let shearCut = this.roundServiceMeters(this.shearCutConception);
        this.shearCutService = shearCut;
        let price = (this.shearCutService / 100) * this.sheetTypeInfo.priceShearCut;
        console.log(price);
        return price;
        //console.log(this.totalService);
      }
      if (this.isShearCutAvailable && (this.sheetTypeInfo.thicknessCommercialMm <= 9) && (this.requestShearCut) && (this.shearCutConception == 0)) {
        // console.log("Entro al primer servicio!")
        let shearCut = this.roundServiceMeters(this.getLengthValue + this.getWidthValue);
        this.shearCutService = shearCut;
        let price = (this.shearCutService / 100) * this.sheetTypeInfo.priceShearCut;
        console.log(price);
        return price;
        //console.log(this.totalService);
      }
      if (this.isShearCutAvailable && (this.sheetTypeInfo.thicknessCommercialMm > 9) && this.requestShearCut) {
        alert(this.generalAlert);
        this.shearCutService = 0;
        return 0;
      }
      return 0;
    },
    calculatePlasmaCutting() {
      // console.log(this.otherCuttingSConception);
      if (this.isPlasmaAvailable && this.requestPlasma && (this.sheetTypeInfo.thicknessCommercialMm <= 25) && (this.otherCuttingSConception > 0)) {
        let plasma = this.roundServiceMeters(this.otherCuttingSConception);
        this.plasmaService = plasma;
        let price = (this.plasmaService / 100) * this.sheetTypeInfo.pricePlasmaCutting;
        console.log(price);
        return price;
      }
      if (this.isPlasmaAvailable && this.requestPlasma && (this.sheetTypeInfo.thicknessCommercialMm <= 25) && (this.otherCuttingSConception == 0)) {
        let plasma = this.roundServiceMeters((this.getLengthValue * 2) + (this.getWidthValue * 2));
        this.plasmaService = plasma;
        let price = (this.plasmaService / 100) * this.sheetTypeInfo.pricePlasmaCutting;
        console.log(price);
        return price;
      }
      if (this.isPlasmaAvailable && this.requestPlasma && (this.sheetTypeInfo.thicknessCommercialMm > 25)) {
        alert(this.generalAlert);
        this.plasmaService = 0;
        return 0;
      }
      return 0;
    },
    calculateLaserCutting() {
      // console.log(this.otherCuttingSConception);
      if (this.isLaserAvailable && this.requestLaser && (this.sheetTypeInfo.thicknessCommercialMm <= 25) && (this.otherCuttingSConception > 0)) {
        let laser = this.roundServiceMeters(this.otherCuttingSConception);
        this.laserService = laser;
        return (this.laserService / 100) * this.sheetTypeInfo.priceLaserCutting;
      }
      if (this.isLaserAvailable && this.requestLaser && (this.sheetTypeInfo.thicknessCommercialMm <= 25) && (this.otherCuttingSConception == 0)) {
        let laser = this.roundServiceMeters((this.getLengthValue * 2) + (this.getWidthValue * 2));
        this.laserService = laser;
        return (this.laserService / 100) * this.sheetTypeInfo.priceLaserCutting;
      }
      if (this.isLaserAvailable && this.requestLaser && (this.sheetTypeInfo.thicknessCommercialMm > 25)) {
        alert(this.generalAlert);
        this.laserService = 0;
        return 0;
      }
      return 0;
    },
    calculateFlameCutting() {
      // console.log(this.otherCuttingSConception);
      if (this.isFlameCutAvailable && (this.sheetTypeInfo.thicknessCommercialMm > 3) && (this.requestFlameCut) && (this.otherCuttingSConception > 0)) {
        let flameCut = this.roundServiceMeters(this.otherCuttingSConception);
        this.flameCuttingService = flameCut;
        let price = (this.flameCuttingService / 100) * this.sheetTypeInfo.priceFlameCutting;
        console.log(price);
        return price;
      }
      if (this.isFlameCutAvailable && (this.sheetTypeInfo.thicknessCommercialMm > 3) && (this.requestFlameCut) && (this.otherCuttingSConception == 0)) {
        let flameCut = this.roundServiceMeters((this.getLengthValue * 2) + (this.getWidthValue * 2));
        this.flameCuttingService = flameCut;
        let price = (this.flameCuttingService / 100) * this.sheetTypeInfo.priceFlameCutting;
        console.log(price);
        return price;
      }
      if (this.isFlameCutAvailable && (this.sheetTypeInfo.thicknessCommercialMm <= 3) && this.requestFlameCut) {
        alert(this.generalAlert);
        this.flameCuttingService = 0;
        return 0;
      }
      return 0;
    },
    calculateFold() {
      if (this.getSheetImageInfo.imgServiceFold > 0) {
        let fold = this.roundServiceMeters((this.getSheetImageInfo.imgServiceFold) * this.getLengthValue);
        this.foldService = fold;
        let price = (this.foldService / 100) * this.sheetTypeInfo.priceFold;
        console.log(price);
        return price;
      }
      if (this.getSheetImageInfo.imgServiceFold > 0 && (this.sheetTypeInfo.thicknessCommercialMm > 9)) {
        alert(this.generalAlert);
        this.foldService = 0;
        return 0;
      }
      return 0;
    },
    calculateWeldingElectrode() {
      if (this.isWeldingElectrodeAvailable) {
        let weldingElectrode = this.roundServiceMeters(this.getWidthValue)
        this.weldingElectrodeService = weldingElectrode;
        return (this.weldingElectrodeService / 100) * this.sheetTypeInfo.priceWeldingElectrode;
      } else {
        return 0;//console.log("El servicio no aplica")
      }
    },
    calculateWeldingMig() {
      if (this.isWeldingMigAvailable) {
        let weldingMig = this.roundServiceMeters(this.getWidthValue);
        this.weldingMigService = weldingMig;
        return (this.weldingMigService / 100) * this.sheetTypeInfo.priceWeldingMig;
      } else {
        return 0;
      }
    },
    calculateRolled() {
      if (this.isRolledAvailable) {
        //let rolled = this.roundServiceWeight(this.getWeight);
        this.rolledService = this.getWeight;
        return this.rolledService * this.sheetTypeInfo.priceRolled;
      } else {
        return 0;
        // console.log("El servicio no aplica")
      }
    },
    calculateConicalRolled() {
      if (this.isConicalRolledAvailable) {
        //let conicalRolled = this.roundServiceWeight(this.getWeight);
        this.conicalRolledService = this.getWeight;
        return this.conicalRolledService * this.sheetTypeInfo.priceRolledConical;
      } else {
        return 0;
        // console.log("El servicio no aplica")
      }
    },
    calculatePunching() {
      //console.log(this.diametersValue);
      let totalPunching = 0;  // Inicializa un acumulador
      if (this.diametersValue.length > 0) {
        this.diametersValue.forEach((diameter) => {
          //console.log(diameter);
          if (diameter <= 4) {
            totalPunching += this.punching1(diameter);
          } else {
            totalPunching += this.punching2(diameter);
          }
        });
      }
      return totalPunching;
    },
    punching1(diametre) {
      if (this.getSheetImageInfo.imgServicePunching1 > 0 && this.requestShearCut) {
        //console.log("Primer If de punching1")
        this.punching1Service = this.getSheetImageInfo.imgServicePunching1;
        let price = this.getSheetImageInfo.imgServicePunching1 * this.sheetTypeInfo.pricePunching1;
        console.log(price);
        return price;
      }
      return 0;
    },
    punching2(diametre) {
      if (this.getSheetImageInfo.imgServicePunching2 > 0 && this.requestShearCut) {
        this.punching2Service = this.getSheetImageInfo.imgServicePunching2;
        let price = this.getSheetImageInfo.imgServicePunching2 * this.sheetTypeInfo.pricePunching2;
        console.log(price);
        return price;
      }
      return 0;
    },
    calculateConvex() {
      if (this.isConvexAvailable) {
        this.convexService = this.getWeight;
        return this.convexService * this.sheetTypeInfo.priceConvex;
      } else {
        return 0;
        // console.log("El servicio no aplica")
      }
    },
    calculateEyelashed() {
      if (this.isEyelashedAvailable) {
        this.eyelashedService = this.getWeight;
        return this.eyelashedService * this.sheetTypeInfo.priceEyelashed;
      } else {
        return 0;
        // console.log("El servicio no aplica")
      }
    },
    calculateOtherServices() {
      return this.otherService;
    },
    roundServiceMeters(number) {
      if (number >= 1 && number <= 100) {
        return 100;
      } else if (number > 100 && number <= 200) {
        return 200;
      } else if (number > 200 && number <= 300) {
        return 300;
      }
      else if (number > 300 && number <= 400) {
        return 400;
      }
      else if (number > 400 && number <= 500) {
        return 500;
      }
      else if (number > 500 && number <= 600) {
        return 600;
      }
      else if (number > 600 && number <= 700) {
        return 700;
      }
      else if (number > 700 && number <= 800) {
        return 800;
      }
      else if (number > 800 && number <= 900) {
        return 900;
      }
      else if (number > 900 && number <= 1000) {
        return 1000;
      }
      else if (number > 1000 && number <= 1100) {
        return 1100;
      }
      else if (number > 1100 && number <= 1200) {
        return 1200;
      }
      else if (number > 1300 && number <= 1400) {
        return 1300;
      }
      else if (number > 1400 && number <= 1500) {
        return 1400;
      }
      else if (number > 1500 && number <= 1600) {
        return 1500;
      }
      else {
        // Si el número no coincide con ninguna de las condiciones anteriores, devolvemos el número sin redondear.
        return number;
      }
    },
    roundPunchingMeters(number) {
      if (number >= 1 && number <= 50) {
        return 50;
      } else if (number > 50 && number <= 100) {
        return 100;
      } else if (number > 100 && number <= 150) {
        return 150;
      }
      else if (number > 150 && number <= 200) {
        return 200;
      }
      else if (number > 200 && number <= 250) {
        return 250;
      }
      else if (number > 250 && number <= 300) {
        return 300;
      }
      else if (number > 300 && number <= 350) {
        return 350;
      }
      else if (number > 350 && number <= 400) {
        return 400;
      }
      else if (number > 400 && number <= 450) {
        return 450;
      }
      else if (number > 450 && number <= 500) {
        return 500;
      }
      else {
        // Si el número no coincide con ninguna de las condiciones anteriores, devolvemos el número sin redondear.
        return number;
      }
    },
    replaceSqrtOrPowInConception(conception) {
      // Reemplazamos "RAIZ" por la función Math.sqrt
      var newConception = conception.replace(/\bRAIZ\b/gi, 'Math.sqrt');

      // Reemplazamos "POTENCIA" por la función Math.pow
      newConception = newConception.replace(/\bPOTENCIA\b/gi, 'Math.pow');
      return newConception;
    },
    evaluateServiceConceptions(conception, D, DT, R, A) {
      try {
        // Reemplazar las variables en la fórmula con los valores correspondientes
        var conceptionValues = conception
          .replace(/D\[(\d+)\]/g, function (match, p1) {
            return D[p1];
          })
          .replace(/DT\[(\d+)\]/g, function (match, p1) {
            return DT[p1];
          })
          .replace(/R\[(\d+)\]/g, function (match, p1) {
            return R[p1];
          })
          .replace(/A\[(\d+)\]/g, function (match, p1) {
            return A[p1];
          });

        // Evaluar la fórmula con los valores reemplazados
        var result = eval(conceptionValues);

        return result;
      } catch (error) {
        console.error("Error al evaluar la fórmula:", error);
        return NaN; // o algún otro valor que indique un error en la evaluación
      }
    },
    getMeasuresAndTransform() {
      // Obtener medidas de la forma (Distancias, Diámetros,Radios y Ángulos)
      this.distancesValue = this.getMeasures.distances;
      this.diametersValue = this.getMeasures.diameters;
      this.radiusValue = this.getMeasures.radius;
      this.anglesValue = this.getMeasures.angles;
      // console.log(this.distancesValue);
      // console.log(this.diametersValue);
      // console.log(this.radiusValue);
      // console.log(this.anglesValue);
      //Agujeros oblongos con cálculo diferente
      if (this.getSheetImageInfo.imgServicePunching2 > 0 && this.diametersValue.length === 0) {
        this.diametersValue.push(5);
      }
      if (this.shearCutServiceConception != "") {
        let conceptionSC = this.replaceSqrtOrPowInConception(this.shearCutServiceConception);
        console.log(conceptionSC);
        this.shearCutConception = this.evaluateServiceConceptions(conceptionSC, this.distancesValue, this.diametersValue, this.radiusValue, this.anglesValue);
      } else {
        this.shearCutConception = 0;
      }
      if (this.otherCuttingServicesConception != "") {
        let conceptionOS = this.replaceSqrtOrPowInConception(this.otherCuttingServicesConception);
        console.log(conceptionOS);
        this.otherCuttingSConception = this.evaluateServiceConceptions(conceptionOS, this.distancesValue, this.diametersValue, this.radiusValue, this.anglesValue);
      } else {
        this.otherCuttingSConception = 0;
      }
      //console.log(this.shearCutConception);
      //console.log(this.otherCuttingSConception);
    }
  },
}
</script>
<style scoped>
.card {
  border: solid 2px #a6323b;
}

input [type="number"] {
  padding: 2px 6px 2px 16px;
  border: solid 5px #999999;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}

textarea {
  min-width: 500px;
  min-height: 80px;
}

.avilable-input {
  background-color: #FCE196;
}
</style>